import {CardTextMainColor} from '@/root/models/card';

export const CARD_TEXT_COLOR_CLASSNAME = {
  [CardTextMainColor.BLACK]: 'type_dark',
  [CardTextMainColor.WHITE]: 'type_light'
} as const;
